import { useParams } from 'react-router-dom';

import { AppUsersPage } from '~/components/pages/AppUsersPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppUsersRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUsersPage appId={appId} />
    </DashboardTemplate>
  );
};
